import { AfterViewInit, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from "../../../config-provider.service";

@Component({
  selector: 'footer-elitment',
  providers: [],
  styleUrls: ['./footer-elitment.scss'],
  standalone: true,
  templateUrl: './footer-elitment.html'
})
export class FooterComponent implements AfterViewInit {
    @Input() public hasLeftMenu = true;

    public year = 2000;
    constructor(
        public conf: ConfigProvider,
        private _translater: TranslateService
    ) {
        this.year = (new Date()).getFullYear();
    }

    public ngAfterViewInit() {
    }
}
